import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchToegangscontroles, toggleToegangscontrole, testToegangscontrole, refreshToken } from './Reducers/actions';
import ToegangscontroleForm from './Components/ToegangscontroleForm';
import DoorsyRealestates from './Components/DoorsyRealestates';
import SneaTabs from '../../../Components/SneaTabs';
import moment from 'moment';

const ToegangscontroleIndex = ({
  toegangscontroles,
  fetchToegangscontroles,
  toggleToegangscontrole,
  testToegangscontrole,
  refreshToken,
  error,
  testResult
}) => {
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState({ show: false, provider: null });
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    loadToegangscontroles();
  }, []);

  const loadToegangscontroles = async () => {
    setLoading(true);
    await fetchToegangscontroles();
    setLoading(false);
  };

  const handleToggle = async (id) => {
    await toggleToegangscontrole(id);
    await loadToegangscontroles();
  };

  const handleTest = async (id) => {
    await testToegangscontrole(id);
  };

  const handleTestWebhook = async (id) => {
    try {
      const response = await fetch(`/api/admin/toegangscontrole/${id}/test-webhook`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
      });

      const data = await response.json();

      if (data.success) {
        alert(`Webhook test succesvol! ${data.message}`);
      } else {
        alert(`Webhook test gefaald: ${data.message}`);
      }
    } catch (error) {
      console.error('Webhook test error:', error);
      alert('Er is een fout opgetreden bij het testen van de webhook');
    }
  };

  const handleRefreshToken = async (id) => {
    const result = await refreshToken(id);
    if (result.success) {
      alert('Access token succesvol vernieuwd!');
      await loadToegangscontroles();
    } else {
      alert(`Fout bij vernieuwen token: ${result.message || result.error}`);
    }
  };

  const handleGetAuthCode = () => {
    const config = doorsyConfig?.configuratie;
    if (!config) {
      alert('Configureer eerst Doorsy voordat je een authcode kunt ophalen');
      return;
    }

    if (!config.client_id || !config.api_base_url) {
      alert('Client ID en API Base URL zijn vereist voor authcode ophalen');
      return;
    }

    // Build the authorization URL according to the template provided
    const baseUrl = config.api_base_url.replace(/\/$/, ''); // Remove trailing slash
    const clientId = encodeURIComponent(config.client_id);

    const authUrl = `${baseUrl}/oauth/authorize/?response_type=code&client_id=${clientId}`;

    // Show instructions and open the authorization URL
    alert('Ga naar de Doorsy autorisatie pagina. Na autorisatie kopieer je de code uit de URL (na ?code=) en plak deze in het configuratie formulier onder "Authorization Code".');
    window.open(authUrl, '_blank', 'width=600,height=600');
  };

  const handleConfigure = (provider = 'doorsy') => {
    setShowForm({ show: true, provider });
  };

  const handleFormClose = () => {
    setShowForm({ show: false, provider: null });
    loadToegangscontroles();
  };

  const getDoorsyConfig = () => {
    return toegangscontroles.find(t => t.naam === 'doorsy');
  };

  const getStatusBadge = (config) => {
    if (!config) return <span className="badge bg-secondary">Niet geconfigureerd</span>;
    
    switch (config.status) {
      case 'niet_geconfigureerd':
        return <span className="badge bg-secondary">Niet geconfigureerd</span>;
      case 'geconfigureerd':
        return <span className="badge bg-warning">Geconfigureerd</span>;
      case 'geautoriseerd':
        return <span className="badge bg-success">Geautoriseerd</span>;
      case 'fout':
        return <span className="badge bg-danger">Fout</span>;
      default:
        return <span className="badge bg-secondary">Onbekend</span>;
    }
  };


  if (loading) {
    return (
      <div className="box box-default">
        <div className="box-body text-center">
          <i className="fas fa-spinner fa-spin"></i> Laden...
        </div>
      </div>
    );
  }

  const doorsyConfig = getDoorsyConfig();

  // Tabs configuration voor SneaTabs component
  const tabs = [
    {
      id: 'configuration',
      label: 'Configuratie',
      icon: 'fas fa-cog',
      content: (
        <div className="row">
          <div className="col-md-12 mb-4">
            <div className="card border-0">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="fas fa-door-closed me-2 text-info"></i>
                  Doorsy API Configuratie
                </h5>
                <p className="text-muted mb-3">
                  Integratie met Doorsy voor toegangscontrole en reserveringsbeheer.
                </p>

                {doorsyConfig && (
                  <>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <small className="text-muted d-block">Laatste update:</small>
                        <strong>{moment(doorsyConfig.bijgewerkt).fromNow()}</strong>
                      </div>
                      <div className="col-md-6">
                        <small className="text-muted d-block">Authentication:</small>
                        <strong className="text-info">
                          {doorsyConfig.configuratie?.auth_type?.replace('_', ' ').toUpperCase() || 'API Key'}
                        </strong>
                      </div>
                    </div>

                    {doorsyConfig.fout_bericht && (
                      <div className="alert alert-danger">
                        <i className="fas fa-exclamation-circle me-2"></i>
                        {doorsyConfig.fout_bericht}
                      </div>
                    )}
                  </>
                )}

                <div className="btn-group w-100" role="group">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleConfigure('doorsy')}
                  >
                    <i className="fas fa-cog me-1"></i>
                    Configureren
                  </button>

                  {doorsyConfig && (
                    <>
                      <button
                        className={`btn ${doorsyConfig.actief ? 'btn-warning' : 'btn-success'}`}
                        onClick={() => handleToggle(doorsyConfig._id)}
                      >
                        <i className={`fas ${doorsyConfig.actief ? 'fa-pause' : 'fa-play'} me-1`}></i>
                        {doorsyConfig.actief ? 'Uitschakelen' : 'Inschakelen'}
                      </button>

                      {doorsyConfig.configuratie?.auth_type === 'oauth2' && doorsyConfig.configuratie?.client_id && (
                        <>
                          <button
                            className="btn btn-secondary"
                            onClick={handleGetAuthCode}
                            title="Open Doorsy OAuth authorisatie in nieuw venster om authcode op te halen"
                          >
                            <i className="fas fa-external-link-alt me-1"></i>
                            OAuth Authcode
                          </button>

                          <button
                            className="btn btn-warning"
                            onClick={() => handleRefreshToken(doorsyConfig._id)}
                            title="Gebruik refresh token om nieuwe access token op te halen"
                            disabled={!doorsyConfig.oauth_tokens?.refresh_token}
                          >
                            <i className="fas fa-sync-alt me-1"></i>
                            Refresh Token
                          </button>
                        </>
                      )}

                      <button
                        className="btn btn-info"
                        onClick={() => handleTest(doorsyConfig._id)}
                      >
                        <i className="fas fa-vial me-1"></i>
                        Testen
                      </button>

                      {doorsyConfig.configuratie?.webhook_config?.url && (
                        <button
                          className="btn btn-success"
                          onClick={() => handleTestWebhook(doorsyConfig._id)}
                        >
                          <i className="fas fa-webhook me-1"></i>
                          Test Webhook
                        </button>
                      )}
                    </>
                  )}
                </div>

                {/* Test Results */}
                {testResult && (
                  <div className={`alert ${testResult.success ? 'alert-success' : 'alert-danger'} mt-3`}>
                    <i className={`fas ${testResult.success ? 'fa-check-circle' : 'fa-exclamation-circle'} me-2`}></i>
                    <strong>Test resultaat:</strong> {testResult.message}
                    {testResult.user_info && (
                      <div className="mt-2">
                        <small>Gebruiker: {testResult.user_info.name || testResult.user_info.email}</small>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'realestates',
      label: 'Realestates',
      icon: 'fas fa-building',
      content: <DoorsyRealestates />
    }
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="mb-0">
                <i className="fas fa-lock me-2"></i>
                Toegangscontrole - Doorsy
              </h4>
              <div>
                {getStatusBadge(doorsyConfig)}
                {doorsyConfig?.actief && (
                  <span className="badge bg-success ms-2">Actief</span>
                )}
              </div>
            </div>

            <div className="card-body p-0">
              {error && (
                <div className="alert alert-danger m-3 mb-0">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}

              {/* Sneat Tabs Implementation */}
              <div className="p-3">
                <SneaTabs
                  tabs={tabs}
                  defaultActiveTab={activeTab}
                  variant="default"
                  onTabChange={(tabId, index) => setActiveTab(index)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Configuration Modal */}
      {showForm.show && (
        <ToegangscontroleForm
          onClose={handleFormClose}
          provider={showForm.provider}
          existingConfig={getDoorsyConfig()}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  toegangscontroles: state.toegangscontrole?.toegangscontroles || [],
  error: state.toegangscontrole?.error,
  testResult: state.toegangscontrole?.testResult
});

export default connect(mapStateToProps, {
  fetchToegangscontroles,
  toggleToegangscontrole,
  testToegangscontrole,
  refreshToken
})(ToegangscontroleIndex);